var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.302,
    height: 28.302,
    viewBox: "0 0 28.302 28.302",
    fill: "current",
    stroke: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1484.5 -198)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1490.651 204.651)",
    fill: "#fff",
    stroke: "current",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    "data-name": "Line 1",
    x2: 1.814,
    transform: "translate(1485.5 212.151)",
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 1.814,
    transform: "translate(1498.651 199) rotate(90)",
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 1.814,
    transform: "translate(1509.988 212.151)",
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 1.814,
    transform: "translate(1498.651 223.488) rotate(90)",
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 1.814,
    transform: "translate(1507.951 202.852) rotate(135)",
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 1.814,
    transform: "translate(1490.634 220.168) rotate(135)",
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 1.814,
    transform: "translate(1489.351 202.852) rotate(45)",
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 1.814,
    transform: "translate(1506.669 220.168) rotate(45)",
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightItem);
export default __webpack_public_path__ + "static/media/light-item.c70dfaff16dc8fcbb4646a7d3c142d25.svg";
export { ForwardRef as ReactComponent };